import { IonButton, IonButtons, IonIcon, IonItem, IonText, IonThumbnail, IonTitle, IonToolbar } from '@ionic/react';
import { arrowBackOutline } from 'ionicons/icons';
import React, { PropsWithChildren } from 'react';
import { useHistory } from 'react-router';
import './AppHeader.css'

interface AppHeaderProps extends PropsWithChildren {
    title?: string;
    color?: string;
    goBack?: boolean;
    goBackUrl?: string;
    icon_url?: string;
    style?:any
}

const AppHeader: React.FC<AppHeaderProps> = (props) => {

    const history = useHistory();

    return (

        <div style={props.style} >
            {
                props.goBack ?
                    <>
                        <IonToolbar hidden={!props.goBack}>
                            <IonButtons slot="start">
                                <IonButton color='primary' onClick={() => { props.goBackUrl ? history.push(props.goBackUrl) : history.goBack() }}>
                                    <IonIcon slot="icon-only" icon={arrowBackOutline} />
                                </IonButton>
                            </IonButtons>
                            <IonItem lines="none" slot="primary" className='appHeaderItem'>

                                <IonThumbnail className="accountsPage_Thumbnail_Flag" slot="start" hidden={!props.icon_url}>
                                    <img src={props.icon_url} />
                                </IonThumbnail>
                            </IonItem>
                        </IonToolbar>
                        
                        <IonToolbar style={{ marginTop: "0%" }}>
                            <IonItem lines='none' className='appHeaderItem'>
                                <IonText slot='start'>
                                    <h2>
                                        {props.title}
                                    </h2>
                                </IonText>
                            </IonItem>
                        </IonToolbar>

                    </>
                    :
                 
                        <IonItem lines='none' className='appHeaderItem'>
                            <IonText slot='start'>
                                <h2>
                                    {props.title}
                                </h2>
                            </IonText>
                        </IonItem>
              



            }

        </div>


    )
}

export default AppHeader;

